import type { ApiListStructure } from "~/modules/nuxt3-module-doyac/composables/common"
import { useDYAppConfig } from "~/modules/nuxt3-module-doyac/composables/config"
import type { DYFileFormData } from "~/modules/nuxt3-module-doyac/composables/dy-file-uploader"
import { $dy__fetchWithToken } from "~/modules/nuxt3-module-doyac/composables/fetch"

export interface DYAPageHelpMemo {
  no: number
  targetSite?: 'doyacweb' | 'doyacart' | 'myfirstguide'
  pageUrl?: string
  /**
   * 260922 추가. 개별 주소 전용 메모일 때의 실제 경로(쿼리스트링 제외, 예 `/tourguide/route/139`).
   * 값이 없으면(null/undefined) 기존처럼 pageUrl(페이지) 단위로 해당 화면 전체에서 노출된다.
   */
  exactPageUrl?: string | null
  componentId?: string
  sectionId?: string
  helpContents: string
  userid?: string
  userName?: string
  secret?: boolean
  insertedTime: any
  updatedTime: any
}

type DYAPageHelpMemoApiFields
  = keyof DYAPageHelpMemo
  | '$all'

export interface DYAPageHelpMemoGetListParams {
  $fields?: DYAPageHelpMemoApiFields[]
  page?: string | number
  perPage?: string | number
  // keyword?: string
  targetSite?: 'doyacweb' | 'doyacart' | 'myfirstguide' | string
  userid?: string
  pageUrl?: string
  componentId?: string
  sectionId?: string
}

export interface DYAPageHelpMemoFormParams {
  no?: number
  targetSite?: 'doyacweb' | 'doyacart' | 'myfirstguide' | 'doyacinc'
  pageUrl?: string
  /**
   * 260922 추가. 개별 주소 전용으로 등록할 때의 경로. 해제 시에는 반드시 `null` 을 보내야 기존 값이 지워진다
   * (undefined 로 보내면 JSON 에서 키가 빠져 서버가 기존 값을 그대로 유지한다).
   */
  exactPageUrl?: string | null
  componentId?: string
  sectionId?: string
  helpContents: string
  secret?: boolean
  contentImageFileData?: DYFileFormData
}

export function useDYAPageHelpMemoApi() {
  const { API_BASE_URL } = useDYAppConfig()
  const baseApiUrl = `${API_BASE_URL}/api/page-help-memos`

  const getList = async (params?: DYAPageHelpMemoGetListParams): Promise<ApiListStructure<DYAPageHelpMemo>> => {
    return await $dy__fetchWithToken<ApiListStructure<DYAPageHelpMemo>>(
      baseApiUrl,
      { query: { ...params, $fields: JSON.stringify(params?.$fields) } }
    )
  }

  const insert = async (params: DYAPageHelpMemoFormParams): Promise<DYAPageHelpMemo> => {
    const url = baseApiUrl
    return await $dy__fetchWithToken<DYAPageHelpMemo>(url, { method: 'post', body: params })
  }

  const update = async (params: DYAPageHelpMemoFormParams): Promise<DYAPageHelpMemo> => {
    return await $dy__fetchWithToken<DYAPageHelpMemo>(
      `${baseApiUrl}/${params.no}`,
      { method: 'put', body: params }
    )
  }

  const remove = async (no: number) => {
    return await $dy__fetchWithToken<{ success: boolean }>(
      `${baseApiUrl}/${no}`,
      { method: 'delete' }
    )
  }

  return {
    getList, insert, update, remove
  }
}